import { useOnMount } from "~/common/hooks/useOnMount";
import { trackAffiliateOnLoad } from "~/app/analytics/ga/affiliate";
import { selectSavedAffiliate, selectVisitedAffiliate } from "~/domains/affiliate/redux/selectors";
import { useSelector } from "react-redux";

export const useAffiliateTracking = () => {
  const savedAffiliate = useSelector(selectSavedAffiliate);
  const visitedAffiliate = useSelector(selectVisitedAffiliate);

  useOnMount(() => trackAffiliateOnLoad(savedAffiliate, visitedAffiliate));
};
